// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2On7q","buttons":"SendReceipts_buttons__3oUvo","email":"SendReceipts_email__1mUCP","bookApptTitle":"SendReceipts_bookApptTitle__22O3O"};